import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	profileHeaderWrapper: {
		display       : "flex",
		flexDirection : "column",
		borderRadius  : "10px",
		margin        : "2rem 0"
	},
	profileBadge: {
		// marginLeft: "5px",
		...theme.other.svgIcons.size20
		// marginTop: "5px"
	},
	verifiedIcon: {
		// marginLeft: "5px",
		...theme.other.svgIcons.size20
		// marginTop: "5px"
	},
	profileHeaderTop: {
		display              : "flex",
		flexWrap             : "wrap",
		justifyContent       : "space-between",
		alignItems           : "center",
		padding              : "1.25rem 1.5rem",
		marginBottom         : "1px",
		borderTopLeftRadius  : "10px",
		borderTopRightRadius : "10px",
		borderBottom         : `1px solid ${ theme.other.colors.border.primary }`
	},
	profileHeaderBackButton: {
		display    : "flex",
		alignItems : "center"
	},
	svgIcons: {
		cursor : "pointer",
		width  : "2.5rem",
		height : "2.5rem",

		"&.mr-2": {
			marginRight: "1.5rem"
		}
	},
	svgIconBack: {
		width  : "2.5rem",
		cursor : "pointer",
		margin : "0 0.5rem"
	},
	backButtonTag: {
		fontSize   : "22px",
		fontWeight : "500",
		margin     : "0 0.5rem"
	},
	profileHeaderIcons: {
		display    : "flex",
		alignItems : "center"
	},

	profileHeaderMiddle: {
		display                 : "flex",
		flexDirection           : "column",
		padding                 : "0 2rem",
		borderBottomLeftRadius  : "10px",
		borderBottomRightRadius : "10px",

		[rooterMediaQuery.mobile]: {
			padding: "0 1rem"

		}
	},
	flex: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	},
	profileHeaderDetails: {
		display: "flex"
	},
	profileHeaderAvatarContainer: {
		margin   : "0 0.8rem",
		position : "relative",

		[rooterMediaQuery.mobile]: {
			margin: "unset"
		}
	},
	profileHeaderContentContainer: {
		display       : "flex",
		flexDirection : "column",
		padding       : "1rem 0 1rem 1rem",
		flexGrow      : "1"
	},
	headerNameContainer: {
		width          : "50%",
		display        : "flex",
		justifyContent : "space-between",

		[rooterMediaQuery.tablet]: {
			width: "60%"
		}
	},
	headerName: {
		whiteSpace : "break-spaces",
		fontWeight : "500"
	},
	headerLocationContainer: {
		display    : "flex",
		gap        : "1rem",
		marginLeft : "-3px"
	},
	headerFollowerContainer: {
		display: "flex"
	},
	UgcStatsSub: {
		display         : "flex",
		padding         : "2.5rem 0",
		background      : "#efefef",
		justifyContent  : "center",
		"& :last-child" : {
			borderRight: "none !important"
		}
	},
	actorAvatar: {
		width        : "100px",
		height       : "100px",
		objectFit    : "contain",
		position     : "relative",
		borderRadius : "50%",

		[rooterMediaQuery.mobile]: {
			width  : "70px",
			height : "70px"
		}
	},
	actorAvatarActive: {
		width        : "100px",
		height       : "100px",
		objectFit    : "contain",
		border       : "2px solid #126bd5",
		position     : "relative",
		borderRadius : "50%",
		padding      : "1px",
		cursor       : "pointer"
	},
	profileHeaderBio: {
		margin: "0.8rem",
		// fontWeight : "500",

		[rooterMediaQuery.mobile]: {
			fontWeight: "unset"
		}
	},
	celebIcon: {
		display    : "flex",
		alignItems : "center",
		marginLeft : "0.5rem",
		position   : "absolute",
		right      : "0",
		bottom     : "0"
	},
	subLeft: {
		display    : "flex",
		alignItems : "center"
	},
	subRight: {
		flex       : 1,
		alignSelf  : "center",
		marginLeft : "2rem"
	},
	nameContainer: {
		display     : "flex",
		alignItems  : "center",
		marginRight : "0.8rem"
	},
	nameText: {
		fontWeight   : "500",
		marginBottom : "0.5rem",
		marginRight  : "1rem"
	},
	subDetailsContainer: {
		overflow                  : "hidden",
		color                     : "#b1b1b1",
		display                   : "flex",
		alignItems                : "center",
		gap                       : "1rem",
		[rooterMediaQuery.mobile] : {
			gap: "0.5rem"
		},
		"& svg": {
			"& path": {
				fill: "#b1b1b1"
			}
		}
	},
	profileHeaderMiddleBottom: {
		display  : "flex",
		flexWrap : "wrap",
		gap      : "1rem",
		maxWidth : "fit-content"
	},
	socialMediaIcons: {
		position: "relative"
	},
	UgcStatContainer: {
		padding     : "0 1.5rem",
		borderRight : "1px solid #d6d6d6",
		minWidth    : "fit-content"
		// flex: "1"
	},
	UgcStatContainerTop: {
		padding    : "0.5rem",
		fontWeight : "500",
		// fontSize   : "16px",
		textAlign  : "center",
		"& span"   : {
			fontSize: "11px"
		}
	},
	UgcStatContainerBottom: {
		color                   : "#929292",
		display                 : "flex",
		marginTop               : "2px",
		alignItems              : "center",
		justifyContent          : "center",
		"& .MuiTypography-root" : {
			marginLeft: "5px"
		}
	},
	followUserContainer: {
		padding                 : "10px 15px",
		"& .MuiButtonBase-root" : {
			width         : "100%",
			textTransform : "capitalize",
			fontWeight    : "500",
			borderRadius  : "8px"
		}
	},
	unfollowButton: {
		// fontSize: "1.6rem",

		[rooterMediaQuery.mobile]: {
			width        : "100%",
			borderRadius : "1rem"
		}
	},
	unfollowButtonText: {
		color    : "rgb(255, 255, 255) !important",
		fontSize : "13px !important"
	},
	followButtonLabel: {
		fontSize   : "1.4rem",
		padding    : "1rem",
		fontWeight : 500
	},
	followButton: {
		padding      : "1.6rem 2rem",
		background   : theme.other.paletteNew.primaryLinearGradient,
		border       : "none",
		borderRadius : "1rem"
	},
	followButtonText: {
		fontSize: "13px !important"
	},
	followerCountNumber: {
		fontWeight : "500",
		display    : "inline"
	},
	followerCountTag: {
		marginLeft : "4px",
		display    : "inline"
	},
	svgIconLocation: {
		height : "15px",
		width  : "15px"
	},
	svgIconCalendar: {
		height : "12px",
		width  : "12px"
	},
	leftNameContainer: {
		display    : "flex",
		alignItems : "center",
		flex       : "1",
		fontWeight : "500"
	},
	ugcStatsSubWrapper: {
		width          : "80%",
		display        : "flex",
		justifyContent : "center"
	},
	settingsIcon: {
		cursor     : "pointer",
		display    : "flex",
		alignItems : "center",
		marginLeft : "10px"
	},
	liveButton: {
		border          : theme.other.darkMode ? "none" : "1px solid white",
		width           : "40px",
		color           : "white",
		position        : "absolute",
		top             : "86px",
		left            : "30px",
		display         : "flex",
		justifyContent  : "center",
		alignItems      : "center",
		fontWeight      : "500",
		borderRadius    : "5px",
		cursor          : "pointer",
		backgroundImage : "linear-gradient(rgb(18, 107, 213), rgb(67, 154, 255))"
	},
	liveText: {
		letterSpacing : "1px",
		fontSize      : "12px"
	},
	menuContainer: {

		"& .MuiMenu-profile-stats": {
			boxShadow  : `${ theme.other.colors.boxShadow.primary } !important`,
			background : theme.other.colors.background.primary,

			"& .MuiMenu-list": {
				backgroundColor : theme.other.colors.background.tertiary,
				padding         : 0
			}
		}
	},
	menuItem: {
		"&:hover": {
			// backgroundColor: `${ "rgb(38 36 36)" }`
		}
	},
	testMenuContainer: {
		backgroundColor: "red"
	},
	forwardIcon: {
		width  : "1.25rem",
		height : "1.25rem"
	},
	statsContainer: {
		display        : "flex",
		alignItems     : "center",
		width          : "100%",
		justifyContent : "space-between"
	},
	statsText: {
		display    : "flex",
		alignItems : "center"
	},
	chipStyles: {
		fontWeight: 500
	},
	buttonStyles: {
		borderRadius : "10px !important",
		border       : "solid 1px #e7e7e7",
		padding      : "0.25rem 1.25rem !important",
		margin       : "0.6rem",
		cursor       : "default",

		"&:hover": {
			backgroundColor: "#fff"
		},

		[rooterMediaQuery.mobile]: {
			padding: "0.25rem 1.25rem !important"
		}
	},
	gameImageStyles: {
		height       : "21px",
		width        : "21px",
		borderRadius : "5px"
	},
	chipContentStyles: {
		display    : "flex",
		alignItems : "center",
		padding    : "2px 0px"
	},
	gameNameStyles: {
		fontSize      : "14px",
		fontWeight    : "normal",
		margin        : "0px",
		paddingLeft   : "5px",
		textTransform : "none"
	},
	leftSideWrapper: {
		display    : "flex",
		alignItems : "center",
		maxWidth   : props?.isOwnProfile ? "55%" : "86%",
		gap        : "0.2rem"
	},
	rightSideWrapper: {
		display    : "flex",
		alignItems : "center"
	},
	threeDotModal: {
		justifyContent : "center",
		alignItems     : "center",
		display        : "flex",
		marginLeft     : "1rem"
	},

	// mobile css
	mobileContainer: {
		// display: "flex"
		// justifyContent : "space-between",
		// alignItems : "center"
	},

	mobileImageContainer: {
		marginRight: "1rem"
	},
	mobileUserInfoContainer: {
		display        : "flex",
		flexDirection  : "column",
		gap            : "0rem",
		overflow       : "hidden",
		justifyContent : "space-evenly",
		flex           : 1
	},
	mobileProfileAndInfoContainer: {
		display      : "flex",
		marginBottom : "0.5rem"
	},
	li: {
		padding : "0.6rem 1.6rem",
		display : "flex"

	},
	followBtn: {
		minHeight  : "3.5rem",
		padding    : "0.75rem 2rem",
		minWidth   : "12rem",
		fontWeight : "500"
	},
	proHexagonDropdown: {
		backgroundColor : "transparent",
		border          : "none",
		padding         : "0",
		paddingLeft     : "1.2rem",
		paddingTop      : "1.2rem"
	}
} ) );

